import React, { useEffect } from "react";
//import ServicesButtonList from "../components/ServicesButtonList";
import AOS from "aos";
import "aos/dist/aos.css";
import Schema from "./Schema";
import ServiceNavigator from "./ServiceNavigator";

const BirdProofing = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="font-sans text-gray-900 bg-gray-100">
    <Schema />
      {/* Hero Section with Black Background */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-3xl">
          <h2 className="text-5xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Bird & Rodent Proofing for Solar Systems
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-4">
            Protect your solar investment from animals with world-class proofing solutions.
          </p>
          <p className="italic text-gray-400">
            Exclusively available through Solar Care International Pvt Ltd
          </p>
        </div>
      </section>

      {/* Info Block */}
      <section
        className="px-6 py-14 max-w-4xl mx-auto text-lg leading-relaxed space-y-14"
        data-aos="fade-up"
      >
        <div>
          <p className="mb-6 text-justify text-gray-700">
            For the very first time in Sri Lanka, <strong>Solar Care International Pvt Ltd</strong> introduces bird and rodent proofing
            services for domestic, commercial, and industrial rooftop solar plants.
          </p>
          <p className="mb-6 text-justify text-gray-700">
            Protect your solar photovoltaic system from damage caused by birds, rodents, squirrels, and monkeys with our stress-free,
            globally recognized solutions. Animal interference can cause power generation losses, void your warranty, and lead to costly repairs.
            Most importantly, our proofing helps prevent fire hazards caused by animal damage to your DC cables.
          </p>
          <p className="text-yellow-700 font-semibold italic text-center">
            “Bird Proofing Solar Panels Can Drastically Cut Down Time & Money Needed For Repairs To Your Solar Panels”
          </p>
        </div>
      </section>

      {/* Details Sections */}
      <section className="px-6 py-14 max-w-4xl mx-auto space-y-14" data-aos="fade-up">
        <article>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">What is Bird Proofing?</h2>
          <p className="text-gray-700 text-justify leading-relaxed">
            Bird and rodent proofing involves installing a protective barrier around your solar panel perimeter to prevent animals from entering,
            nesting, or damaging the panels and wiring beneath. This keeps your solar system safe and operational.
          </p>
        </article>

        <article>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">Commercial & Domestic Installations</h2>
          <p className="text-gray-700 leading-relaxed">
            Our skilled technicians have over 10 years of experience protecting solar systems from animal damage. We offer tailored
            proofing solutions for both domestic rooftops and large commercial or industrial solar arrays.
          </p>
        </article>

        <article>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">Warranty & Quality Assurance</h2>
          <ul className="list-disc list-outside text-gray-700 space-y-2 max-w-md">
            <li>
              <strong>10 Years Warranty</strong> on our in-house manufactured reusable stainless steel fasteners, ensuring long-lasting durability.
            </li>
            <li>
              <strong>5 Years Warranty</strong> on our high-quality galvanized welded PVC coated mesh that forms the protective barrier.
            </li>
          </ul>
        </article>
      </section>

            {/* Image Showcase Section */}
            <section className="px-6 py-14 max-w-6xl mx-auto space-y-12" data-aos="fade-up">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center text-black">
                Our Work in Action
              </h2>

              {/* Top Row: Three Images */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                <img
                  src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751364874/WhatsApp_Image_2025-06-15_at_3.50.41_PM_jtybzf.jpg"
                  alt="Bird Proofing Example 1"
                  className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105"
                />
                <img
                  src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751364875/WhatsApp_Image_2025-06-15_at_3.52.17_PM_qeyxke.jpg"
                  alt="Bird Proofing Example 2"
                  className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105"
                />
                <img
                  src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751364873/WhatsApp_Image_2025-06-15_at_3.52.19_PM_gtdqvh.jpg"
                  alt="Bird Proofing Example 3"
                  className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105"
                />
              </div>

              {/* Bottom Row: One Large Image */}
              {/* <div>
                <img
                  src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751364873/WhatsApp_Image_2025-06-15_at_3.52.19_PM_gtdqvh.jpg"
                  alt="Large Bird Proofing Showcase"
                  className="rounded-3xl shadow-xl w-full object-cover max-h-[600px] transition-transform duration-300 hover:scale-105"
                />
              </div> */}
            </section>


      {/* Why Choose Us */}
      <section
        className="px-6 py-14 max-w-4xl mx-auto"
        data-aos="fade-up"
      >
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">
          Why Choose Solar Care International?
        </h2>
        <ul className="list-disc list-outside text-gray-700 space-y-3 max-w-md mx-auto text-lg">
          <li>Decade-long expertise in solar system protection and maintenance</li>
          <li>Premium-grade materials with industry-leading warranties</li>
          <li>Proven record of protecting thousands of solar installations island-wide</li>
          <li>Trained technicians with a commitment to quality and safety</li>
          <li>Comprehensive support for domestic and commercial clients</li>
        </ul>
      </section>

      {/* Contact Section with Flex Styling */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-2xl">
          <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Get in Touch
          </h2>
          <p className="mb-2 font-medium">Solar Care International Pvt Ltd</p>
          <p className="mb-1">No.44/1A, Chapel Lane, Nugegoda, Sri Lanka</p>
          <p className="mb-1">+94 114 199 225 / +94 777 129 021</p>
          <p>
            <a
              href="mailto:info@solarcareinternational.com"
              className="text-blue-400 hover:text-blue-200 underline transition"
            >
              info@solarcareinternational.com
            </a>
          </p>
        </div>
        </div>
      </section>

      {/* <ServicesButtonList /> */}
      <ServiceNavigator />
    </div>
  );
};

export default BirdProofing;